<template>
  <Layout>
  <div class="section content is-size-7">
    <p>
        E-Mail: <a href="mailto:cuca@778mobile.com">cuca@778mobile.com</a> <br>
    </p>
  </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/KE/Help.vue